// Module visant à mettre à disposition sous forme de module l'objet global
// contenant les différentes configs carto.
const Carto = window.Carto;

// Calcul et mise en cache du calcul de l'extent max
const extentMax = Carto ? Carto.config.options.extent : [];

export { Carto, extentMax };
